import { Component, OnDestroy, OnInit } from '@angular/core';

import { AbstractBaseComponent } from '@ib-shared/abstract/abstract-base';
import { takeUntil } from 'rxjs';

import { DashboardFacadeService } from '../services/dashboard-facade.service';
import { DashboardStateService } from '../services/dashboard-state.service';

@Component({
  selector: 'ib-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [DashboardStateService, DashboardFacadeService],
})
export class DashboardComponent
  extends AbstractBaseComponent
  implements OnInit, OnDestroy
{
  public isTransferModalShow$ = this.facadeS.selectIsTransferModalShow();
  public isAddDocsModalShow$ = this.facadeS.selectShowAddDocsModal();

  constructor(private facadeS: DashboardFacadeService) {
    super();
  }

  closeTranferModal(): void {
    this.facadeS.toggleTransferModal(false);
  }

  closeAddDocModal(): void {
    this.facadeS.toggleAddDocsModal(false);
  }

  ngOnInit(): void {
    this.facadeS.initIsAddDocsModalShow();
    this.facadeS.initShowTransferMoneyModal();
    this.facadeS.fetchBalances().pipe(takeUntil(this.destroy$)).subscribe();
  }

  ngOnDestroy(): void {
    super.destroySubscriptions();
  }
}
